import { Td as ChakraTd, TableCellProps } from '@chakra-ui/react';

export const Td = (props: TableCellProps) => <ChakraTd px="2" {...props} />;
